import { DataTable } from "@/components/data-table";
import { alertsColumns } from "@/features/alerts/components/alerts-columns";
import { useAlertsList } from "@/features/alerts/hooks/useAlertsList";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import ListContent from "@/features/alerts/components/list-content";
import SearchInput from "@/components/search-input";
import AlertsFilterComponent from "@/features/alerts/components/filter-component";
import { useAlertsFilterStore } from "@/features/alerts/stores";
import { useEffect } from "react";

const WarningsPage = () => {
  const { t } = useTranslation();
  const { alerts, page, pageCount, setPage, isLoading, isFetching } =
    useAlertsList();
  const {
    searchValue,
    setSearchValue,
    setAlertTypeFilter,
    setFrequencyFilter,
  } = useAlertsFilterStore();

  useEffect(() => {
    return () => {
      setSearchValue(null);
      setAlertTypeFilter(null);
      setFrequencyFilter(null);
    };
  }, [setSearchValue, setAlertTypeFilter, setFrequencyFilter]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("keys.search")}
        />
        <AlertsFilterComponent />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={alertsColumns(t)}
          data={alerts}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={
            <EmptyTable title={t("modules.alerts.datatable.no_alerts")} />
          }
        />
      </div>
      <ListContent
        data={alerts}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={
          <EmptyTable title={t("modules.alerts.datatable.no_alerts")} />
        }
      />
    </div>
  );
};

export default WarningsPage;
